import { WorkspaceState } from './workspace-state';
import { WorkspaceVisibility } from './workspace-visibility';

export enum WorkspaceMarker {
  onlineVisible = 'ONLINEVISIBLE',
  onlineHidden = 'ONLINEHIDDEN',
  offlineVisible = 'OFFLINEVISIBLE',
  offlineHidden = 'OFFLINEHIDDEN'
}
